import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const PaywallChargesComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "PaywallChargesPage" */ "@circle-react/components/SettingsApp/PaywallChargesAdminApp"
    ),
);

export const PaywallChargesPage = () => (
  <Suspense fallback={<PageLoader />}>
    <PaywallChargesComponent />
  </Suspense>
);
